export var InterviewVideoRoutes = {
    "/interview-video/application/{applicationId:[0-9]*}/interview/{interviewId:[0-9]*}": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "interview_video_applicant",
        "type": "frontend",
        "component": "interviewVideoApplicantContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview-video"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-video.module.js");
                }
            }
        ]
    },
    "/interview-video/{applicationId:[0-9]*}/{interviewId:[0-9]*}": {
        "loginRequired": false,
        "showGlobalSearch": false,
        "name": "interview_video_applicant_check_browser",
        "type": "frontend",
        "component": "interviewVideoCheckBrowser",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["interview-video"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./interview-video.module.js");
                }
            }
        ]
    }
};